import { Record } from 'immutable';
import ContentType from '../ContentType';

const MonthlyExpenseRecord = Record({
  id: null,
  comments: null,
  created: null,
  updated: null,
  amount: null,
  month: null,
  year: null,
  expense: null,
});

class MonthlyExpense extends MonthlyExpenseRecord {
  static contentType = ContentType.PAY;

  get getId() {
    return this.get('id');
  }
}

export default MonthlyExpense;
